import { useEffect } from 'react';
function useAccordionItem(_ref) {
  var accIndex = _ref.accIndex,
    _ref$openedItems = _ref.openedItems,
    openedItems = _ref$openedItems === void 0 ? [] : _ref$openedItems,
    onOpenItem = _ref.onOpenItem,
    onCloseItem = _ref.onCloseItem,
    open = _ref.open,
    openCallback = _ref.openCallback,
    closeCallback = _ref.closeCallback;
  var isItemOpened = openedItems.includes(accIndex);
  useEffect(function () {
    if (open) {
      onOpenItem(accIndex);
    }
  }, []);
  function headClickHandler() {
    if (isItemOpened) {
      onCloseItem(accIndex);
      if (closeCallback) closeCallback();
    } else {
      onOpenItem(accIndex);
      if (openCallback) openCallback();
    }
  }
  return {
    isItemOpened: isItemOpened,
    headClickHandler: headClickHandler
  };
}
export { useAccordionItem as default };